import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import {
  IPagination,
  IPaginationResult,
  IRequestResult,
  IResult,
} from "app/common/interfaces";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  CombinedFilter,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  select,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import { ICreateMemberNotification, IUpdateMemberNotification } from "./interfaces/member-interface";
import NotificationMemberAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/notification/notification-member/notification-member.entity";
import { IFilters } from "../../filters/interfaces/filterInterface";

const apiUrl = env.API_AVE_NOTIFICATION;
const moduleName = "notification_member";

@Injectable({
  providedIn: "root",
})
export class MemberNotificationService extends AbstractService<
  NotificationMemberAttributes,
  ICreateMemberNotification,
  IUpdateMemberNotification
> {

  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * List
   * @param filter CombinedFilter of related entity - NotificationMemberAttributes
   * @returns Data list
   */
  getAllPaginate(
    options: IPagination<any>,
    dataToFilter?: IFilters
  ): Observable<IPaginationResult<any>> {
    const query = buildQuery<any>(
      where("_deleted", Ops.eq(false)),
      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),

      dataToFilter && dataToFilter.companyId ? andAllWhere('company.id', Ops.eq(dataToFilter.companyId)) : noop(),
      //dataToFilter && dataToFilter.salesOfficeId && dataToFilter.salesOfficeId.length > 0 ? andAllWhere('salesOffice.id', Ops.in(...dataToFilter.salesOfficeId)) : noop(),
      //dataToFilter && dataToFilter.distributionChainId && dataToFilter.distributionChainId.length > 0 ? andAllWhere('distributionChain.id', Ops.in(...dataToFilter.distributionChainId)) : noop(),
      dataToFilter && dataToFilter.status && dataToFilter.status.length > 0 ? andAllWhere('statusId', Ops.in(...dataToFilter.status)) : noop(),

      page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/withCount?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IPaginationResult<any>>(API_URL);
  }

  getCombo(data): Observable<IRequestResult<NotificationMemberAttributes[]>> {
    const query = buildQuery<any>(
      where("_deleted", Ops.eq(false)),
      andWhere(<any>"company._id", Ops.eq(data.companyId)),
      andWhere(<any>"statusId", Ops.eq(1)),
      orderBy(
         "name",
         OrderVariant.Asc
      )
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/filter?filter=${encodeURIComponent(JSON.stringify(query))}`;
    return this.http.get<IRequestResult<NotificationMemberAttributes[]>>(API_URL);
  }
}
